'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var React = require('react');
var Footer_web_styles = require('./Footer.web.styles.cjs');

/**
 * Modal Footer component - typically contains action buttons
 */ const Footer = ({ children, customCss, ...props })=>{
    const footerStyles = React.useMemo(()=>[
            Footer_web_styles.footer,
            customCss
        ], [
        customCss
    ]);
    return /*#__PURE__*/ jsxRuntime.jsx("div", {
        css: footerStyles,
        ...props,
        children: children
    });
};

exports.Footer = Footer;
//# sourceMappingURL=Footer.web.cjs.map
